import { useMutation, useQueryClient } from "react-query";
import QueryKey from "../QueryKey";
import { postToggleMatTypeFav } from "../services/cust-service";

// Star/unstar a favourite material type for the logged-in user, then refresh
// the matType dropdown lists so favourites float to the top.
export default function useToggleMatFav() {
    const queryClient = useQueryClient();
    const mutation = useMutation(postToggleMatTypeFav, {
        onSuccess: () => {
            queryClient.invalidateQueries(QueryKey.matTypes);
            queryClient.invalidateQueries(QueryKey.matTypesByCat);
        }
    });
    return (material) => mutation.mutate(material);
}
